import { render, staticRenderFns } from "./Titulo.vue?vue&type=template&id=1e140e32&"
import script from "./Titulo.vue?vue&type=script&lang=js&"
export * from "./Titulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports